import './ScoreInput.scss'
import React from 'react'
import classnames from 'classnames'
import KeyListener from './KeyListener'

const ScoreButton = ({ value, selected, onClick }) => {
  const className = classnames('ScoreButton', selected && 'ScoreButton-selected')
  return (
    <button className={className} onClick={onClick}>
      <span className='ScoreButton-full'>{value}</span>
      <span className='ScoreButton-min'>{value / 2}</span>
    </button>
  )
}

const ScoreInput = ({ value, onChange, className }) => {
  const numbers = [1,2,3,4,5,6,7,8,9,10]
  return (
    <div className={classnames('ScoreInput', className)}>
      <ul className='ScoreInput_options'>
        {numbers.map(num =>
          <li key={num}>
            <ScoreButton
              value={num}
              selected={num === value}
              onClick={() => onChange(num)}
            />
          </li>
        )}
      </ul>
      <div className='ScoreInput_label'>
        <span>Strongly Disagree</span>
        <span>Strongly Agree</span>
      </div>
      <KeyListener onNumber={onChange} />
    </div>
  )
}

ScoreInput.displayName = 'ScoreInput'

export default ScoreInput



// WEBPACK FOOTER //
// ./src/lib/ScoreInput.js